import React, { useState } from 'react';

// project-imports
import { TestimonialTwoParams } from '../../utils/script';
import { TestimonialTwoThumDots } from '../../utils/script';
import { _setBgColor } from '../../utils';
import { useTestimonialContext } from '../../context/testimonial_context';

// third party
import Slider from 'react-slick';
import Avatar from 'react-avatar';

const TestimonialReactJs = ({ classes, item, courseDomain }) => {

    // Extracting variables from context
    const { testimonials, testimonialError } = useTestimonialContext();

    // State variables
    const [testimonialNav, setTestimonialNav] = useState();
    const [testimonialThumb, setTestimonialThumb] = useState();

    // Local variable
    let testimonialsData = (courseDomain && courseDomain === "All") ? testimonials : (testimonials || []).filter(item => item.course === 'ReactJs');
    testimonialsData = item ? testimonialsData.slice(0, item) : testimonialsData;

    return (
        <div className={classes}>
            <Slider className="testimonial-nav-activation"
                asNavFor={testimonialThumb}
                ref={(slider1) => setTestimonialNav(slider1)}
                {...TestimonialTwoParams}
            >
                {(testimonialsData || [])?.map((item, i) => (
                    <div className="testimonial-nav-content" key={i}>
                        <p className="description">“ {item.details}”</p>
                        <div className="client-info">
                            <h6 className="title">{item.name}</h6>
                            <span className="designation">{item.designation}</span>
                        </div>
                    </div>
                ))}
            </Slider>

            <div className="testimonial-nav-wrapper">
                {Boolean(testimonialsData && testimonialsData.length && !testimonialError) &&
                    <Slider className="testimonial-nav-button"
                        {...TestimonialTwoThumDots}
                        asNavFor={testimonialNav}
                        ref={(slider2) => setTestimonialThumb(slider2)}
                    >
                        {testimonialsData.map((item, i) => (
                            <div className="single-thumbnail" key={i}>
                                <Avatar name={(item.name) || "Guest User"} size='60' maxInitials={1} color={_setBgColor((item && item.name && item.name) || "Guest User")} textSizeRatio={2} round />
                                <div className="loader-container">
                                    <div className="circle-loader-wrap">
                                        <div className="left-wrap">
                                            <div className="loader"></div>
                                        </div>
                                        <div className="right-wrap">
                                            <div className="loader"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                }
            </div>
        </div>
    );
}
export default TestimonialReactJs;